// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar--sidebar--f48f32","links":"Sidebar--links--399293"};